import React, { useState } from 'react'

export default function usePutAuthed(url, urlIdentifier = null) {
    const [error, setError] = useState();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);

    const call = async (data, newUrl = null) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${urlIdentifier === 'loan' ? process.env.REACT_APP_LOAN_API_URL : process.env.REACT_APP_API_URL}/${newUrl ? newUrl : url}`, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${urlIdentifier === 'loan'
                        ? JSON.parse(localStorage.getItem('loanAuth'))
                            ? JSON.parse(localStorage.getItem('loanAuth')).token
                            : JSON.parse(localStorage.getItem('bankAdmin')).data.token
                        : JSON.parse(localStorage.getItem('authUser')).data?.token}`
                },
            }
            );
            const result = await response.json()
            if (response.ok) {
                // const result = await response.json();
                setData(result);
            } else {
                setError(result);
                // setError({ error: { message: 'There was an error processing.' } });
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return [call, data, error, loading];
}
